import React from "react";

import { EvidenceSignals } from "pages/admin/verifications/components/automations/EvidenceSignals";
import { EvidenceSignal, EvidenceTone } from "pages/admin/verifications/components/automations/types";

type TimelineTileEvidenceProps = {
  signals: EvidenceSignal[];
  tone: EvidenceTone;
  title: string;
};

export const TimelineTileEvidence = ({ signals, tone, title }: TimelineTileEvidenceProps) => (
  <div className={`tile-strip ${tone}`} title={title}>
    <EvidenceSignals signals={signals} />
  </div>
);
